import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import React from "react";

export function generatePdfReport({
  reportTitle,
  fileNamePrefix,
  subtitle,
  headers,
  rows,
  custoColIndex = 3,
  enabledColumns,
  footerLines = [],
}: {
  reportTitle: string;
  fileNamePrefix: string;
  subtitle: string;
  headers: string[];
  rows: (string | number | React.ReactNode)[][];
  custoColIndex?: number;
  enabledColumns?: number[];
  footerLines?: string[];
}) {
  const doc = new jsPDF();

  const columnIndexes =
    enabledColumns && enabledColumns.length > 0
      ? enabledColumns
      : headers.map((_, i) => i);

  const filteredHeaders = columnIndexes.map((i) => headers[i]);
  const filteredRows = rows.map((row) =>
    columnIndexes.map((i) =>
      typeof row[i] === "string" || typeof row[i] === "number"
        ? String(row[i])
        : ""
    )
  );

  const logoImg =
    "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"; // Completo no seu código
  doc.addImage(logoImg, "PNG", 16, 12, 17, 7.5);

  const companyInfo = [
    "**GOOGLEMARINE ELETRONICA NAVAL LTDA**",
    "**https://googlemarine.com.br/**",
    "",
    "CNPJ: 28.366.167/0001-90",
    "Inscrição Estadual: 11.646.22-0",
    "",
    "R DELEGADO WALDIR GUILHERME, 32",
    "ILHA DA CONCEICAO",
    "Niteroi - RJ - CEP: 24050-170",
    "Telefone: (21) 3614-0926",
  ];

  doc.setFontSize(9);
  let y = 10;
  let enderecoY = 0;
  companyInfo.forEach((line) => {
    const isBold = line.startsWith("**") && line.endsWith("**");
    const cleanLine = line.replace(/\*\*/g, "");
    doc.setFont("helvetica", isBold ? "bold" : "normal");
    doc.text(cleanLine, 200, y, { align: "right" });
    if (cleanLine.startsWith("R DELEGADO")) enderecoY = y;
    y += 4;
  });

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text(reportTitle, 14, enderecoY + 5);

  const now = new Date();
  const formattedDate = now.toLocaleDateString("pt-BR").replace(/[/]/g, "/");
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(
    `Data de Geração do Relatório: ${formattedDate}`,
    14,
    enderecoY + 10 // Posição ajustada
  );

  // Adicionando o Horário de Geração do Relatório
  const formattedTime = now.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  doc.text(
    `Horário de Geração do Relatório: ${formattedTime}`,
    14,
    enderecoY + 15 // Posição ajustada
  );

  // Ajustando o subtítulo para ficar próximo do título
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text(subtitle, 14, enderecoY + 40); // Posição ajustada

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  let yFooter = y + 30; // Ajuste no yFooter para garantir que não há grandes espaçamentos
  footerLines.forEach((line) => {
    doc.text(line, 14, yFooter);
    yFooter += 5;
  });

  doc.setFontSize(7);
  autoTable(doc, {
    startY: yFooter + 5,
    head: [filteredHeaders],
    body: filteredRows,
    styles: {
      fontSize: 9,
      halign: "center",
      valign: "middle",
      lineColor: [0, 0, 0],
      lineWidth: 0.25,
      cellPadding: 2,
    },
    headStyles: {
      fillColor: [18, 66, 128],
      textColor: 255,
      fontStyle: "normal",
    },
    bodyStyles: {
      lineColor: [0, 0, 0],
    },
    margin: { left: 13, right: 10 },
    tableWidth: "auto",
  });

  const formattedDateTime = now
    .toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .replace(/[\/:]/g, "-")
    .replace(",", "");

  doc.save(`${fileNamePrefix}-${formattedDateTime}.pdf`);
}
